import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { finalize, map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Logger, AuthenticationService, UserService } from '@app/core';
import { JwtService } from '@app/core/services/jwt.service';
const log = new Logger('Login');

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  version: string = '1';//environment.version;
  error: string;
  loginForm: FormGroup;
  isLoading = false;
  message = "";
  msgColor: string;
  asterik: string;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private jwtService: JwtService,
    private userService: UserService,
    private spinnerService: Ng4LoadingSpinnerService,
    private authenticationService: AuthenticationService) {
    this.createForm();
  }
  ngOnInit() {
  }
  login() {
    this.isLoading = true;
    
    this.authenticationService.login(this.loginForm.value)
      .pipe(finalize(() => {
        this.loginForm.markAsPristine();
        this.isLoading = false;
      }))
      .subscribe(
        credentials => {
          window.localStorage['LoginFailureCount'] = 0;
          this.router.navigate(['/home'], { replaceUrl: true });
        },
        error => {
          console.log("error description " + error.error_description);
          if (error.error_description == 'Bad credentials') {
            if (isNaN(window.localStorage['LoginFailureCount'])) {
              window.localStorage['LoginFailureCount'] = 0;
            }
            window.localStorage['LoginFailureCount'] = parseInt(window.localStorage['LoginFailureCount']) + 1;
            if (parseInt(window.localStorage['LoginFailureCount']) >= 5) {
              console.log("Locking " + this.loginForm.value.username + " Account " + window.localStorage['LoginFailureCount']);
            
              this.userService.getTokenFromAuthServer().subscribe(
                  data => {
                    console.log('Token Saved');
                    this.userService.lockUser(this.loginForm.value.username).subscribe(
                      response => {
                        this.message = "There have been too many unsuccessful login attempts. You have been locked out for 1 hour. Please try again later.";
                        this.msgColor = 'red';
                        this.asterik = '*';
                        window.localStorage['LoginFailureCount'] = 0;
                      },
                      error => {
                        window.localStorage['LoginFailureCount'] = 0;
                      }
                    );
                  },
                  err => {        
                    console.log('Unable to connect to API URL');
                  }
                );
              
            } else {
              this.message = "Invalid Username And/Or Password";
              this.msgColor = 'red';
              this.asterik = "*"
            }
          } else if (error.error_description == "User got Disabled") {
            this.message = "User is disabled can't login";
            this.msgColor = 'red';
            this.asterik = "*"
          } else if (error.error_description == "User got Blocked") {
            this.message = "Error Code 333B - Contact your Administrative Office.";
            this.msgColor = 'red';
            this.asterik = "*"
          } else if (error.error_description == 'User account is locked') {
            this.message = "There have been too many unsuccessful login attempts. You have been locked out for 1 hour. Please try again later.";
            this.msgColor = 'red';
            this.asterik = '*';
          } else if (error.error_description == "User account is expired") {
            this.message = "User expired can't login";
            this.msgColor = 'red';
            this.asterik = "*"
          } else {
            if (error.currentTarget.status == "0") {
              this.message = "service is temporarily down, please try again after sometime";
              this.msgColor = 'red';
              this.asterik = "*"
            }
          }
          log.debug(`Login error: ${error}`);
          this.error = error;
        });
  }
  identity() {
    this.router.navigate(['/identity'], { replaceUrl: true });
  }
  forgotUsername() {
    this.router.navigate(['/identity'], { replaceUrl: true, queryParams: { 'link': 'forgotUsername' } });
  }
  forgotPassword() {
    this.router.navigate(['/identity'], { replaceUrl: true, queryParams: { 'link': 'forgotPassword' } });
  }
  getStatusColor() {
    return this.msgColor;
  }
  onPasswordChange() {
    this.message = "";
    this.msgColor = 'red';
    this.asterik = ""
  }
  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: true
    });
  }
}
